import {getDisplayableShortGrade} from '../../shared/services';
import {List} from 'immutable';
import React, {PropTypes} from 'react';

export default function LessonDetailHeader({lessonType, grades, characterName, title, createdDate, createdBy}) {

  const gradeDisplay = grades => {
    if (!grades) return null;
    if (grades.size === 1) return getDisplayableShortGrade(grades.first().toJS());
    return grades.map(g => g.get('short')).join(', ');
  };

  let subHeaderText = lessonType;
  const gradeDisplayText = gradeDisplay(grades);
  subHeaderText += gradeDisplayText ? ` - ${gradeDisplayText}` : '';
  subHeaderText += characterName ? ` - ${characterName}` : '';

  let createdDisplayText = createdDate || '';
  createdDisplayText += createdBy ? ` by ${createdBy}` : '';

  return (
    <div>
      <div className="lesson-detail-subheader">
        {subHeaderText}
      </div>
      <div className="lesson-detail-main"><i>{title}</i></div>
      <div className="lesson-detail-created-date">
        {createdDisplayText}
      </div>
    </div>
  );
}

LessonDetailHeader.propTypes = {
  characterName: PropTypes.string,
  createdBy: PropTypes.string,
  createdDate: PropTypes.string,
  grades: PropTypes.instanceOf(List),
  lessonType: PropTypes.string,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/LessonDetailHeader.js